import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.events__splide' ).each( function( _index, element ) {
        const slider = new Splide( element, {
          type: 'slide',
          gap: '32px',
          perPage: 3,
          perMove: 1,
          pagination: false,
          arrows: true,
          drag: true,
          speed: 800,
          breakpoints: {
            1024: {
              perPage: 2,
            },
            768: {
              perPage: 1,
              gap: '20px',
            },
          },
        } );

        slider.on( 'overflow', function( isOverflow ) {
          element.classList.toggle( 'is-overflow', isOverflow );

          slider.options = {
            arrows: isOverflow,
            drag: isOverflow,
          };
        } );

        slider.mount();
      } );
    },
    finalize: function() {},
  };
  app.registerComponent( 'events', COMPONENT );
} )( app );
